import { render, staticRenderFns } from "./ModalMarketSession.vue?vue&type=template&id=621ee972"
import script from "./ModalMarketSession.vue?vue&type=script&lang=js"
export * from "./ModalMarketSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports